import { useState } from 'react'
import { Button } from './ui/button'
import { Send } from 'lucide-react'
import { toast } from 'sonner'
import { useAuthStore } from '../stores/authStore'
import { API_CONFIG } from '../lib/config'

interface TelegramButtonProps {
    productId: string
    size?: 'sm' | 'default' | 'lg'
    variant?: 'default' | 'outline' | 'secondary'
    className?: string
}

export default function TelegramButton({
    productId,
    size = 'sm',
    variant = 'outline',
    className = ''
}: TelegramButtonProps) {
    const [sending, setSending] = useState(false)
    const { accessToken } = useAuthStore()

    const sendToTelegram = async () => {
        if (!productId) {
            toast.error('Ürün ID bulunamadı')
            return
        }

        setSending(true)
        try {
            const response = await fetch(`${API_CONFIG.BASE_URL}/api/telegram/send-product`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ productId })
            })

            const data = await response.json()

            if (response.ok && data.success) {
                toast.success('Ürün bilgileri Telegram\'a gönderildi!')
            } else {
                toast.error(data.error || 'Telegram\'a gönderim başarısız')
            }
        } catch (error) {
            console.error('Telegram send error:', error)
            toast.error('Telegram\'a gönderim sırasında hata oluştu')
        } finally {
            setSending(false)
        }
    }

    return (
        <Button
            size={size}
            variant={variant}
            onClick={sendToTelegram}
            disabled={sending}
            className={`${className} ${sending ? 'opacity-50' : ''}`}
            title="Ürün bilgilerini Telegram'a gönder"
        >
            <Send className="w-3 h-3" />
            {sending ? 'Gönderiliyor...' : ''}
        </Button>
    )
}
